<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Delete period</p>
      </header>
      <section class="modal-card-body">
        <p>
          Are you sure you want to delete period {{ adPeriod.startTimestamp }} -
          {{ adPeriod.endTimestamp }}?
        </p>

        <!-- Error notification section -->
        <div class="notification is-danger" v-if="deleteError">
          {{ deleteError }}
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="container">
          <div class="is-pulled-right">
            <button class="button" @click="cancelModal" :disabled="isDeleting">Cancel</button>
            <button
              class="button is-danger"
              @click="confirmDelete"
              :class="{ 'is-loading': isDeleting }"
              :disabled="isDeleting"
            >
              Delete
            </button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { DELETE_AD_PERIOD } from '@/modules/ads/adsStore'

export default {
  name: 'AdDeletePeriodModal',

  props: {
    adsStorePath: {
      type: String,
      required: true
    },

    adPeriod: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      isDeleting: false,
      deleteError: null
    }
  },

  methods: {
    cancelModal() {
      this.$emit('cancelled')
    },

    async confirmDelete() {
      const adPeriodId = this.adPeriod.id

      this.isDeleting = true
      this.deleteError = null

      try {
        const deletePeriodAction = `${this.adsStorePath}/${DELETE_AD_PERIOD}`
        await this.$store.dispatch(deletePeriodAction, { adPeriodId })

        this.$emit('succeeded')
      } catch (error) {
        this.deleteError = error || 'Something went wrong.'
      } finally {
        this.isDeleting = false
      }
    }
  }
}
</script>

<style></style>
